/* eslint-disable no-prototype-builtins */

export const isStructureWithoutData = (item) => item.type === 'structure' && !item.structureData;

export const isAdvancedWithoutValue = (item) => item.type === 'advanced' && !item.value;

export const checkChildrenValues = (nodesList) => {
  if (!nodesList || nodesList.length === 0) return true;
  return nodesList.every((item) => {
    return (
      (item.children && item.children.length > 0 && item.children.every((child) => !child.value)) ||
      isStructureWithoutData(item) ||
      isAdvancedWithoutValue(item) ||
      (item.id === 'wrapper' &&
        item.items &&
        item.items.length > 0 &&
        item.items.every(
          (child) =>
            isStructureWithoutData(child) ||
            isAdvancedWithoutValue(child) ||
            (child.id === 'wrapper' &&
              child.items &&
              child.items.length > 0 &&
              child.items.every((childW) => {
                return (
                  isStructureWithoutData(childW) ||
                  isAdvancedWithoutValue(childW) ||
                  (childW.children &&
                    childW.children.length > 0 &&
                    childW.children.every((childS) => !childS.hasOwnProperty('value') || !childS.value))
                );
              })) ||
            (child.children &&
              child.children.length > 0 &&
              child.children.every((childV) => !childV.hasOwnProperty('value') || !childV.value))
        ))
    );
  });
};
